export const AUTH_PATH = "auth";
